import { render, staticRenderFns } from "./AddDieticianAppointmentModal.vue?vue&type=template&id=333348a7&"
import script from "./AddDieticianAppointmentModal.vue?vue&type=script&lang=js&"
export * from "./AddDieticianAppointmentModal.vue?vue&type=script&lang=js&"
import style0 from "./AddDieticianAppointmentModal.vue?vue&type=style&index=0&id=333348a7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports